module.exports = __webpack_public_path__ + "static/media/dublin-2.68a9dd39.jpg";